// extracted by mini-css-extract-plugin
module.exports = {"Container":"Pagination_Container__i6mqu","Info":"Pagination_Info__rLqL6","Actions":"Pagination_Actions__KmVE6","Button":"Pagination_Button__GuZ6_"};